import { useQuery } from '@tanstack/react-query';
import { marketingApi, marketingKeys } from '../marketing/api';
import type { MarketingCampaign } from '../marketing/types';

export const CAMPAIGNS_ALL_KEY = [...marketingKeys.campaigns, 'all'] as const;

/** Общий список всех кампаний: бейдж черновиков, чек-лист, счётчики вкладок, редирект /campaigns/results.
 * Инвалидация marketingKeys.campaigns (префикс) обновляет и этот ключ.
 * Постоянного опроса нет: хук живёт в оболочке на каждом экране, а бейджу черновиков и чек-листу
 * хватает инвалидации marketingKeys.campaigns после действий и refetch при возврате в окно. */
export function useCampaignsAll(enabled = true) {
  return useQuery({
    queryKey: CAMPAIGNS_ALL_KEY,
    queryFn: ({ signal }) => marketingApi.campaigns({ statusGroup: 'all' }, signal),
    staleTime: 15_000,
    enabled,
    select: (data) => data.campaigns,
  });
}

const LAUNCHED = ['active', 'running', 'scheduled', 'sending'];

export function draftsCount(list?: MarketingCampaign[]): number {
  return list?.filter((item) => item.status === 'draft').length ?? 0;
}

export function hasLaunched(list?: { status: string }[]): boolean {
  return !!list?.some((item) => LAUNCHED.includes(item.status));
}

/** Первая кампания с отправками (порядок API). */
export function firstWithSent(list?: MarketingCampaign[]): MarketingCampaign | undefined {
  return list?.find((item) => item.sent > 0);
}
